import React from 'react'
import { STATUS_DRAFT } from '@disco/constants/CampaignTypes'
import CampaignListPage from 'pages/campaigns/campaign-list'

const DraftCampaignListPage = (): React.ReactNode => {
  return <CampaignListPage fullPage={STATUS_DRAFT} />
}

export default DraftCampaignListPage
